import { INavData } from '@coreui/angular';

export const managementNavBaseItems: INavData[] = [
  {
    name: 'Management',
    url: '/game/management',
    iconComponent: { name: 'cil-people' },
    children: [
      {
        name: 'Users',
        url: '/backoffice/management/users',
        iconComponent: { name: 'cil-people' },
      },
      {
        name: 'News',
        url: '/backoffice/management/news',
        iconComponent: { name: 'cil-newspaper' },
      },
      {
        name: 'Bug Reports',
        url: '/backoffice/management/bug-reports',
        iconComponent: { name: 'cil-bug' },
        class: 'bug-reports',
        badge: { color: 'danger', text: '' },
      },
    ]
  }
];
